module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company',
};



// WEBPACK FOOTER //
// ./src/lang/hi/labels.js